import { ModelConfigParams, kidneyChecklistQC } from "./model-config-params";

export const kidney: ModelConfigParams = {
  bodyParts: [
    'tumourWithLesionUncertain',
    'arteryWithUncertainAndKidneySegments',
    'veinWithUncertain',
    'collecting',
    'stone',
    'kidney',
    'cyst',
    'adrenalGland',
    'renalSinusFat',
    'calcification',
    'stent',
    'bladder',
    'unknown',
    'vesselCentreline',
    'lobeKidney',
    'liver',
    'stomach',
    'pancreas',
    'colon',
    'portalVein',
  ],
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    excretory: 'r',
    arteryUncertain: "t",
    veinUncertain: "y",
    cyst: "u",
    leftKidney: "i",
    rightKidney: "o",
    stone: "p",
    calcification: "alt + q",
    renalSinusFat: "alt + w",
    stent: "alt + r",
    unknown: "alt + t",
  },
  checklist: [
    "Tumour boundary [axial/saggital/coronal]",
    "All arterial branches from aorta to kidney [axial/coronal]",
    "All venous branches from VC to kidney [axial/coronal]",
    "Artery/vein crossings in hilum [coronal/axial]",
    "Collecting system boundary near tumour [saggital/coronal]",
    "Gonadal/adrenal veins have been added (if visible) [coronal]",
    "All vessels are connected [3D]",
    "There are no loose blobs [3D]",
    "There are no arteries/veins left unlabeled going into kidney [axial/coronal]",
    "3D model is physiologically plausiable [3D]"
  ],
  checklistQC: kidneyChecklistQC,
  defaultIntensityRange: [-100, 300],
}
